<div class="screen-launcher-container">
  <!-- Loading State -->
  <nz-spin *ngIf="loading && !error" [nzSpinning]="true" [nzTip]="'builderScreen.launcher.loading' | translateTA">
    <div style="height: 400px;"></div>
  </nz-spin>

  <!-- Error State -->
  <nz-result
    *ngIf="error"
    nzStatus="error"
    [nzTitle]="'builderScreen.launcher.loadErrorTitle' | translateTA"
    [nzSubTitle]="errorMessage">
    <div nz-result-extra>
      <button nz-button nzType="primary" (click)="router.navigate(['/'])">
        Voltar ao Início
      </button>
    </div>
  </nz-result>

  <!-- Canvas View -->
  <div class="canvas-wrapper" *ngIf="!loading && !error">
    <tem-screen-view [templateId]="templateId" [data]="screenData"></tem-screen-view>
  </div>

  <!-- Floating Action Buttons (FAB) -->
  <div class="fab-container" *ngIf="!loading && !error" [class.expanded]="isFabExpanded">
    <!-- Backdrop para fechar ao clicar fora -->
    <div class="fab-backdrop" *ngIf="isFabExpanded" (click)="toggleFab()"></div>
    
    <!-- Botões de ação (aparecem quando expandido) -->
    <button 
      class="fab-action fab-action-inject"
      *ngIf="isFabExpanded"
      nz-button
      nzType="primary"
      nzShape="circle"
      nzSize="large"
      (click)="openInjectJsonModal(); toggleFab()"
      nz-tooltip
      [nzTooltipTitle]="'builderScreen.launcher.injectJson' | translateTA"
      nzTooltipPlacement="left">
      <nz-icon nzType="cloud-upload" nzTheme="outline"></nz-icon>
    </button>
    
    <button 
      class="fab-action fab-action-preview"
      *ngIf="isFabExpanded"
      nz-button
      nzType="default"
      nzShape="circle"
      nzSize="large"
      (click)="openFlowJsonPreviewModal(); toggleFab()"
      nz-tooltip
      [nzTooltipTitle]="'builderScreen.launcher.flowPreview' | translateTA"
      nzTooltipPlacement="left">
      <nz-icon nzType="eye" nzTheme="outline"></nz-icon>
    </button>
    
    <button 
      class="fab-action fab-action-clear"
      *ngIf="isFabExpanded"
      nz-button
      nzType="default"
      nzDanger
      nzShape="circle"
      nzSize="large"
      (click)="clearData(); toggleFab()"
      nz-tooltip
      [nzTooltipTitle]="'builderScreen.launcher.clearData' | translateTA"
      nzTooltipPlacement="left">
      <nz-icon nzType="delete" nzTheme="outline"></nz-icon>
    </button>
    
    <!-- Botão principal -->
    <button 
      class="fab-main"
      nz-button
      nzType="primary"
      nzShape="circle"
      nzSize="large"
      (click)="toggleFab()"
      nz-tooltip
      [nzTooltipTitle]="isFabExpanded ? 'Fechar' : 'Controle de Dados'"
      nzTooltipPlacement="left">
      <nz-icon [nzType]="isFabExpanded ? 'close' : 'database'" nzTheme="outline"></nz-icon>
    </button>
  </div>
</div>

<!-- Modal Preview JSON do Fluxo -->
<nz-modal
  [(nzVisible)]="isFlowPreviewVisible"
  [nzTitle]="'builderScreen.launcher.flowPreview' | translateTA"
  nzWidth="850px"
  (nzOnCancel)="isFlowPreviewVisible = false"
  [nzFooter]="flowPreviewFooter">
  
  <ng-container *nzModalContent>
    <div class="flow-preview-modal">
      <!-- Sem botões de fluxo -->
      <nz-alert
        *ngIf="flowButtons.length === 0"
        nzType="info"
        [nzMessage]="'builderScreen.launcher.noFlowButtonTitle' | translateTA"
        [nzDescription]="'builderScreen.launcher.noFlowButtonHint' | translateTA"
        nzShowIcon
        style="margin-bottom: 16px;">
      </nz-alert>

      <!-- Seletor de botão de fluxo -->
      <div *ngIf="flowButtons.length > 0" style="margin-bottom: 16px;">
        <label style="display: block; margin-bottom: 6px; font-weight: 500;">{{ 'builderScreen.launcher.flowButton' | translateTA }}</label>
        <nz-select
          [(ngModel)]="selectedFlowButtonId"
          (ngModelChange)="updateFlowPreview()"
          style="width: 100%;"
          [nzPlaceHolder]="'builderScreen.launcher.selectFlowButton' | translateTA">
          <nz-option
            *ngFor="let btn of flowButtons"
            [nzValue]="btn.id"
            [nzLabel]="btn.label">
          </nz-option>
        </nz-select>
      </div>

      <!-- Info do modo de dados -->
      <div *ngIf="selectedFlowButtonId" style="margin-bottom: 16px;">
        <nz-tag [nzColor]="getSelectedFlowButton()?.flowDataMode === 'selectedItem' ? 'blue' : 'green'">
          {{ getSelectedFlowButton()?.flowDataMode === 'selectedItem' ? 'Item Selecionado' : 'JSON Completo' }}
        </nz-tag>
        <span style="color: #8c8c8c; font-size: 12px; margin-left: 8px;">
          {{ getSelectedFlowButton()?.flowDataMode === 'selectedItem' 
            ? 'Envia apenas a linha selecionada na grade principal' 
            : 'Envia todos os dados da tela' }}
        </span>
      </div>

      <!-- Sem dados -->
      <nz-alert
        *ngIf="flowButtons.length > 0 && !flowPreviewJson"
        nzType="warning"
        [nzMessage]="'builderScreen.launcher.noDataTitle' | translateTA"
        [nzDescription]="'builderScreen.launcher.noDataHint' | translateTA"
        nzShowIcon
        style="margin-bottom: 16px;">
      </nz-alert>

      <!-- JSON formatado -->
      <div *ngIf="flowPreviewJson" class="flow-preview-json">
        <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 8px;">
          <span style="font-weight: 500; color: #595959;">{{ 'builderScreen.launcher.jsonToSend' | translateTA }}</span>
          <button
            nz-button
            nzType="primary"
            nzSize="small"
            (click)="copyFlowJson()">
            <nz-icon nzType="copy" nzTheme="outline"></nz-icon>
            Copiar JSON
          </button>
        </div>
        <pre class="json-display">{{ flowPreviewJson }}</pre>
      </div>
    </div>
  </ng-container>
  
  <ng-template #flowPreviewFooter>
    <button nz-button (click)="isFlowPreviewVisible = false">Fechar</button>
    <button
      nz-button
      nzType="primary"
      [disabled]="!flowPreviewJson"
      (click)="copyFlowJson()">
      <nz-icon nzType="copy" nzTheme="outline"></nz-icon>
      Copiar JSON
    </button>
  </ng-template>
</nz-modal>

<!-- Modal para Injetar JSON -->
<nz-modal
  [(nzVisible)]="isJsonModalVisible"
  [nzTitle]="'builderScreen.launcher.injectJsonTitle' | translateTA"
  nzWidth="800px"
  (nzOnCancel)="handleJsonModalCancel()"
  (nzOnOk)="handleJsonModalOk()"
  [nzOkText]="'Injetar'"
  [nzCancelText]="'Cancelar'"
  [nzOkDisabled]="!isJsonValid">
  
  <ng-container *nzModalContent>
    <div class="json-inject-modal">
      <nz-alert
        [nzType]="replaceMode ? 'warning' : 'info'"
        [nzMessage]="replaceMode ? '⚠️ Modo Substituição Ativo' : 'ℹ️ Cole o JSON que deseja injetar'"
        [nzDescription]="replaceMode ? 'Os dados substituirão COMPLETAMENTE os dados existentes. Todos os dados anteriores serão perdidos!' : 'Os dados serão mesclados com os dados existentes da fonte de dados (se houver). Campos duplicados serão sobrescritos.'"
        nzShowIcon
        [nzCloseable]="false"
        style="margin-bottom: 16px; transition: all 0.3s ease;">
      </nz-alert>

      <!-- ⭐ NOVO: Opção de substituição completa -->
      <div style="margin-bottom: 16px; padding: 12px; background-color: #fafafa; border-radius: 4px; border-left: 3px solid #1890ff;">
        <label nz-checkbox [(ngModel)]="replaceMode">
          <nz-icon [nzType]="replaceMode ? 'warning' : 'swap'" [nzTheme]="replaceMode ? 'filled' : 'outline'" style="margin-right: 8px;"></nz-icon>
          <span style="font-weight: 500;">Substituir dados completamente</span>
        </label>
        <div style="margin-left: 24px; margin-top: 4px; color: #8c8c8c; font-size: 12px;">
          <nz-icon nzType="info-circle" nzTheme="outline" style="margin-right: 4px;"></nz-icon>
          {{ replaceMode ? 'Descarta todos os dados existentes e usa apenas o JSON novo' : 'Mescla o JSON novo com os dados existentes (recomendado)' }}
        </div>
      </div>

      <!-- Editor de JSON -->
      <div class="json-editor">
        <textarea
          nz-input
          [(ngModel)]="jsonInput"
          (ngModelChange)="validateJson()"
          [nzAutosize]="{ minRows: 15, maxRows: 25 }"
          placeholder='{"response": {"item_list": [...]}}'
          spellcheck="false">
        </textarea>
      </div>

      <!-- Mensagem de erro de validação -->
      <nz-alert
        *ngIf="!isJsonValid && jsonInput"
        nzType="error"
        [nzMessage]="'JSON Inválido'"
        [nzDescription]="jsonValidationError"
        nzShowIcon
        style="margin-top: 16px;">
      </nz-alert>

      <!-- Preview do JSON válido -->
      <div *ngIf="isJsonValid && jsonInput" style="margin-top: 16px;">
        <nz-alert
          nzType="success"
          [nzMessage]="'builderScreen.launcher.jsonValidTitle' | translateTA"
          [nzDescription]="'builderScreen.launcher.jsonValidHint' | translateTA"
          nzShowIcon>
        </nz-alert>
      </div>
    </div>
  </ng-container>
</nz-modal>

